const angular = require('angular');
const { some, startsWith } = require('lodash');
const SmartBanner = require('smart-app-banner');

module.exports = function ($rootScope, $state, shopperService, loginService, pageMetadataService, memoScroll, moveFocus, analyticsService, settings, $window, frontendManagementService, trolleyService) {
    function promptForLogin(event, toState, toParams) {
        event.preventDefault();
        loginService.promptForLogin(loginService.LoginToContinueMessage, toState, toParams);
    }

    $rootScope.$on('$stateChangeStart', (event, toState, toParams, fromState, fromParams) => {
        // this condition does not checkout the direct land on this homepage, Trader is already taking care about that,
        // this is only when the user is navigating with the spa.
        // we should have a checkout to whether the user is logged in to content management, but this flag does not exist on the front end, so
        // we had to add  fromState.name !== '' instead that check if leave to Trader to decide which angular version to service for direct landing.
        if (settings.frontendManagement && settings.frontendManagement.useAngular2PlusHomepage && toState.name === 'root' && fromState.name !== '') {
            event.preventDefault();
            $window.location.assign('/'); // Go from this SPA to the Angular2+ SPA
        }

        if (toState.name.startsWith('shop.inspiration') && settings.frontendManagement && settings.frontendManagement.useAngular2PlusDiscover) {
            const url = `/shop/discover${toParams.parent ? `/${toParams.parent}` : ''}${toParams.child ? `/${toParams.child}` : ''}`;
            if (!settings.frontendManagement.discoverEnableUrIs || settings.frontendManagement.discoverEnableUrIs.split(/\s*,\s*/).includes(url)) {
                event.preventDefault();
                $window.location.assign(url);
            }
        }

        if (toState.name.startsWith('shop.myaccount') && settings.frontendManagement && settings.frontendManagement.useAngular2PlusMyAccount) {
            const url = `/shop/myaccount${toState.url}`;
            if (!settings.frontendManagement.myAccountEnableUrIs || settings.frontendManagement.myAccountEnableUrIs.split(/\s*,\s*/).includes(url)) {
                event.preventDefault();
                $window.location.assign(url);
            }
        }

        if (toState.name.startsWith('shop.page') && settings.frontendManagement && settings.frontendManagement.useAngular2PlusShopPage) {
            const url = `/shop/page${toParams.scheduleKey ? `/${toParams.scheduleKey}` : ''}`;
            if (!settings.frontendManagement.shopPageEnableUrIs || settings.frontendManagement.shopPageEnableUrIs.split(/\s*,\s*/).includes(url)) {
                event.preventDefault();
                $window.location.assign(url);
            }
        }


        if (settings.frontendManagement && settings.frontendManagement.useAngular2PlusProductSearch && (toState.name === 'shop.search' || toState.name === 'shop.search.products' || toState.name === 'shop.search.specials' || toState.name === 'shop.search.zero-result') && fromState.name !== '') {
            event.preventDefault();
            const searchType = toState.name === 'shop.search.products' ? 'products' : toState.name === 'shop.search.specials' ? 'specials' : toState.name === 'shop.search.zero-result' ? 'zeroresult' : '';
            $window.location.assign(`/shop/search/${searchType}?searchTerm=${toParams.searchTerm}`); // Go from this SPA to the Angular2+ SPA
        }


        if (settings.frontendManagement && settings.frontendManagement.useAngular2PlusRecipeSearch && toState.name === 'shop.search.recipes') {
            event.preventDefault();
            $window.location.assign(`/shop/search/recipes?searchTerm=${toParams.searchTerm}`); // Go from this SPA to the Angular2+ SPA
            return;
        }


        if (settings.frontendManagement && settings.frontendManagement.EnableMultiFactorAuth && toState.name === 'shop.2fa' && fromState.name !== '') {
            event.preventDefault();
            $window.location.assign('/shop/two-step-auth'); // Go from this SPA to the Angular2+ SPA
        }

        if (toState.name === 'hyf' && fromState.name !== '' && frontendManagementService.useAngular2PlusHaveYouForgotten()) {
            event.preventDefault();
            $window.location.assign('/shop/checkout'); // Go from this SPA to the Angular2+ SPA
        }
        if (settings.frontendManagement && settings.frontendManagement.useAngular2PlusLists && (toState.name === 'shop.guestList' || toState.name === 'shop.list.home') && fromState.name !== '') {
            event.preventDefault();
            $window.location.assign('/shop/mylists'); // Go from this SPA to the Angular2+ SPA
        }

        if (fromState.data && fromState.data.onAuthReturnToState) {
            $rootScope.onAuthRedirectedState = $state.get(fromState.data.onAuthReturnToState);
            $rootScope.onAuthRedirectedStateParams = {};
        } else {
            $rootScope.onAuthRedirectedState = fromState;
            $rootScope.onAuthRedirectedStateParams = fromParams;
        }

        if (toState.data && toState.data.authenticate && shopperService.IsGuest) {
            if (angular.isArray(toState.data.authenticate)) {
                $state.shouldAuthenticate(toState, toParams).then((requiresLogin) => {
                    if (requiresLogin) {
                        promptForLogin(event, toState, toParams);
                    }
                });
            } else {
                promptForLogin(event, toState, toParams);
            }
        }
    });

    $rootScope.$on('$stateChangeSuccess', () => {
        if (!shopperService.IsGuest
            && settings.carePackage.automaticRemoveFromCart
            && settings.carePackage.whitelistedUrls
            && settings.carePackage.whitelistedUrls.length > 0
            && settings.carePackage.whitelistedUrls.indexOf($window.location.pathname) === -1) {
            trolleyService.removeItems(settings.carePackage.packageStockCodes);
        }

        pageMetadataService.useCurrentStateMetadata();

        moveFocus('#body-container', true);
        moveFocus(() => $('#center-panel h1').filter(':first'), false);
    });

    $rootScope.$on('$locationChangeStart', (event, newUrl, oldUrl) => {
        memoScroll.previousUrl = oldUrl;
        memoScroll.currentUrl = newUrl;

        // Scroll has been changed since Angular have already started to render after state change
        // Which means the position of scroll is not expecting to use
        // Hence comment it
        // memoScroll.rememberScrollPosition(oldUrl);
    });

    // Same issue explained above in `$locationChangeStart`
    // Hence comment it
    // $rootScope.$on('$locationChangeSuccess', (event, newUrl, oldUrl = '') => {
    //     // Only restore the scroll position if the path has changed. This is to prevent
    //     // jarring scroll position changes when changing sort by options/product filters.
    //     const hasPathChanged = newUrl.split('?')[0] !== oldUrl.split('?')[0];

    //     if (!($state.current && $state.current.data && $state.current.data.optOutOfScrollRestore) && (hasPathChanged || ($state.current && $state.current.reloadOnSearch))) {
    //         memoScroll.restoreScrollPosition(newUrl);
    //     }
    // });

    $rootScope.$on('$stateChangeSuccess', (event, state) => {
        if (state.name === 'root') {
            analyticsService.push({ type: analyticsService.mapperTypes.content.general, data: { page: 'root' } });
        }

        if (state.name === 'shop.page') {
            analyticsService.push({ type: analyticsService.mapperTypes.content.general });
        }

        if (startsWith(state.name, 'shop.authentication')) {
            analyticsService.push({
                data: { 'page.Type': 'account' },
                type: analyticsService.mapperTypes.content.general,
            });
        }

        if (state.name === 'shop.recipes') {
            analyticsService.push({
                data: { 'page.Type': 'content' },
                type: analyticsService.mapperTypes.content.general,
            });
        }

        if (state.name === 'shop.recipes.noSavedRecipes') {
            analyticsService.push({
                data: { recipes: {} },
                type: analyticsService.mapperTypes.content.recipeCategory,
            });
        }

        if (state.name === 'shop.recipes.recipenotfound') {
            analyticsService.push({
                data: { recipes: {} },
                type: analyticsService.mapperTypes.content.recipeCategory,
            });
        }

        if (state.name === 'shop.list.home') {
            analyticsService.push({
                data: {
                    'page.Type': 'content',
                    'page.TypeVariation': shopperService.IsGuest ? 'Guest' : 'Logged in',
                },
                type: analyticsService.mapperTypes.content.general,
            });
        }

        if (state.name === 'shop.list.reorder') {
            analyticsService.push({
                data: { 'page.Type': 'content' },
                type: analyticsService.mapperTypes.content.general,
            });
        }
        // define other page type tealium push on route change for e.g. /shop/embedded/new-app
        if (state.name) {
            const pageTypeExceptions = settings.analytics.tealiumPageTypeExceptions;
            if (!some(pageTypeExceptions, ex => startsWith(state.name, ex))) {
                analyticsService.push({
                    data: { 'page.Type': 'other' },
                    type: analyticsService.mapperTypes.content.general,
                });
            }
        }
    });

    if (settings.smartBanner.enableSmartBanner === true) {
        // eslint-disable-next-line no-new
        new SmartBanner({
            daysHidden: settings.smartBanner.daysHiddenAfterClose,
            daysReminder: settings.smartBanner.daysHiddenAfterView,
            title: settings.smartBanner.title,
            appStoreLanguage: 'us',
            author: settings.smartBanner.author,
            button: 'VIEW',
            store: {
                ios: settings.smartBanner.appleStore,
                android: settings.smartBanner.googleStore,
            },
            price: {
                ios: 'FREE',
                android: 'FREE',
            },
        });

        $rootScope.$on('$stateChangeSuccess', () => {
            if (document.querySelector("meta[name='apple-itunes-app']") === null) {
                return;
            }

            angular
                .element(document.querySelector("meta[name='apple-itunes-app']"))
                .attr('app-argument', $state.href($state.current.name, $state.params, { absolute: true }));
        });
    }
};



// WEBPACK FOOTER //
// ./src/configuration/startup.js